export default "__VITE_ASSET__BdB5bK8Y__"